import React from "react";
import PropTypes from "prop-types";
import { dataType } from "custom-prop-types";
import { Select } from "components/common/select";
import { ActiveDigitalFilters } from "components/upload-documents/active-digital-filters";
import styles from "components/documents/document-filters.scss";

export const DigitalUploadFilters = (props) => (
  <div className={ styles.container }>
    <h3 className={ styles.title }>Filter by:</h3>
    <div className={ styles["field-cell"] }>
      <span>Processing Status</span>
      <Select
        data={ processingStatus }
        onChange={ (e) => props.onAddStuckStatusFilter(e) }
        placeholder="Select the processing status..."
        value={ props.statusFilter }
      />
    </div>
    <div className={ styles["field-cell"] }>
      <span>Document source</span>
      <Select
        data={ processingSource }
        onChange={ (e) => props.onAddSourceFilter(e) }
        placeholder="Select a document source..."
        value={ props.sourceFilter }
      />
    </div>
    <ActiveDigitalFilters { ...props } />
  </div>
);

DigitalUploadFilters.defaultProps = {
  sourceFilter: null,
  statusFilter: null
};

DigitalUploadFilters.propTypes = {
  onAddSourceFilter: PropTypes.func.isRequired,
  onAddStuckStatusFilter: PropTypes.func.isRequired,
  sourceFilter: dataType,
  statusFilter: dataType
};

const processingStatus = [
  { key: "status_stuck", name: "Stuck documents" },
  { key: "status_not_stuck", name: "Non stuck documents" }
];

const processingSource = [
  { key: "source_email", name: "Email" },
  { key: "source_integration", name: "Digital uploads" },
  { key: "source_mobile", name: "Mobile app" }
];



// WEBPACK FOOTER //
// ./src/js/components/upload-documents/digital-upload-filters.jsx